import client from "./client";

const getUsers = () => client.get("/subsidiary/dashboard/users/all");

export default { getUsers };
